import React from 'react';
import PropTypes from 'prop-types';
import { Card, Paragraph, SmallText } from 'hui';
import { default as NewsletterSubscriptionForm } from './NewsletterSubscriptionForm';

const NewsletterSubscription = ({ subscribeToNewsletter, subscribed, error }) => (
  <Card>
    {!subscribed && !error && (
      <div>
        <Paragraph bold mb={0}>
          Join our newsletter
        </Paragraph>
        <SmallText>
          Enter your details to receive our weekly newsletter, packed with the latest home
          improvement hints, news, products and events.
        </SmallText>
        <NewsletterSubscriptionForm onSubmit={subscribeToNewsletter} />
      </div>
    )}
    {subscribed && (
      <div>
        <Paragraph bold mb={0}>
          Thank you
        </Paragraph>
        <SmallText mb={0}>You are now subscribed to our newsletter</SmallText>
      </div>
    )}
    {error && (
      <div>
        <Paragraph bold mb={0}>
          Uh oh!
        </Paragraph>
        <SmallText mb={0}>Something went wrong, try again later</SmallText>
      </div>
    )}
  </Card>
);

NewsletterSubscription.propTypes = {
  subscribeToNewsletter: PropTypes.func,
  subscribed: PropTypes.bool,
  error: PropTypes.bool
};

export default NewsletterSubscription;
